import { reduxForm } from 'redux-form'
import onSubmit from './onSubmit'
import { shouldAsyncValidate } from '../../containers/Form/FilterRooms/validate'
import { set } from 'lodash'
import i18n from '../../i18n'
import { toast } from 'react-toastify'
import Toast from '../../containers/Toast'
import React from 'react'
import { Mixpanel } from '../../utils/Mixpanel'

export interface IResetPasswordFormValues {
  password: string
  rpassword: string
}

export default reduxForm<IResetPasswordFormValues, {}>({
  destroyOnUnmount: false,
  enableReinitialize: false,
  form: 'passwordResetTokenForm',
  onSubmit,
  shouldAsyncValidate,
  asyncValidate: validate(),
})

function validate() {
  return function(values): Promise<IResetPasswordFormValues> {
    return new Promise((resolve, reject) => {
      const errors: IResetPasswordFormValues = {
        password: null,
        rpassword: null,
      }

      if (!values.password || values.password.length < 8) {
        set(errors, 'password', true)

        toast(
          <Toast.Error>
            {i18n.t('OUT_4234_password_must_8_characters_error')}
          </Toast.Error>,
          {
            autoClose: 5000,
            className: 'error-background',
            containerId: 'Main',
            toastId: 'resetPasswordFormMinLengthError',
          },
        )

        if (values.first === '1') {
          Mixpanel.track('Employee List New Employee Create Password Failed', {
            'Employee ID': values.employee,
            'New Employee Create Password Length': values.password
              ? values.password.length
              : undefined,
            'Registration Failed Terms and Policy Checked?': Boolean(
              values.agreement,
            ),
          })
        }

        reject(errors)
      }

      if (values.password !== values.rpassword) {
        set(errors, 'rpassword', true)
        set(errors, 'password', true)

        toast(
          <Toast.Error>
            {i18n.t('OUT_4234_new_and_repeat_password_error_popup')}
          </Toast.Error>,
          {
            autoClose: 5000,
            className: 'error-background',
            containerId: 'Main',
            toastId: 'resetPasswordFormMatchError',
          },
        )
        if (values.first === '1') {
          Mixpanel.track('Employee List New Employee Create Password Failed', {
            'Employee ID': values.employee,
            'New Employee Create Password Length': values.password
              ? values.password.length
              : undefined,
            'Registration Failed Terms and Policy Checked?': Boolean(
              values.agreement,
            ),
          })
        }
        reject(errors)
      }

      if (values.first === '1' && !values.agreement) {
        set(errors, 'agreement', true)
        toast(
          <Toast.Error>{i18n.t('terms_and_conditions_error')}</Toast.Error>,
          {
            autoClose: 5000,
            className: 'error-background',
            containerId: 'Main',
            toastId: 'resetPasswordFormAgreementError',
          },
        )

        if (values.first === '1') {
          Mixpanel.track('Employee List New Employee Create Password Failed', {
            'Employee ID': values.employee,
            'New Employee Create Password Length': values.password
              ? values.password.length
              : undefined,
            'Registration Failed Terms and Policy Checked?': Boolean(
              values.agreement,
            ),
          })
        }
        reject(errors)
      }

      resolve({} as any)
    })
  }
}
